import { Component, OnInit } from '@angular/core';
import { DataService } from '../data/data.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  email: string;
  sending = null;
  sent = false;

  constructor(
    private dataService: DataService,
  ) { }

  ngOnInit() {
  }

  sendEmail() {
    if (this.email) {
      this.sending = true;
      this.dataService.sendResetPasswordEmail(this.email).subscribe(response => {
        this.sent = true;
      });
    }
  }
}
